import styled from 'styled-components';

import { ScrollbarTheme } from './horizontal-scroller';

// Rounding borders of scrollbar and scrollbar container
const BORDER_RADIUS = '999rem';

export const ScrolleableWrapper = styled.div`
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  ::-webkit-scrollbar {
    -webkit-appearance: none;
    display: none;
  }
  max-width: 100vw;
  overflow: auto;
`;

export const Scrollbar = styled.div<{
  widthPercent: number;
  scrollLeft: number;
  scrollWidth: number;
}>`
  width: ${p => p.widthPercent}%;
  margin-left: ${p => Math.floor((p.scrollLeft / p.scrollWidth) * 100)}%;
  border-radius: ${BORDER_RADIUS};
`;

export const ScrollbarWrapper = styled.div<{ $theme: ScrollbarTheme }>`
  display: flex;
  overflow: auto;
  width: 60%;
  height: 6px;
  background: ${p =>
    p.$theme === ScrollbarTheme.DARK ? Styles.color.grey.eight : 'rgba(189, 91, 0, 0.3)'};
  margin: 1rem auto 0;
  border-radius: ${BORDER_RADIUS};

  ${Scrollbar} {
    background: ${p =>
      p.$theme === ScrollbarTheme.DARK ? Styles.color.grey.one : Styles.color.white};
  }
`;
